import { once } from "../../function/once";
import { makeMessageBus } from "../create-message-bus/index.js";
import type { AddedItemToCart } from "./messages/added-item-to-cart.js";
import type { OpenCartDrawer } from "./messages/open-cart-drawer.js";
import type { SelectedVariant } from "./messages/selected-variant.js";

export type MainBusMessage = AddedItemToCart | OpenCartDrawer | SelectedVariant;

export const initMainBus = once(() => {
    return makeMessageBus<MainBusMessage>();
});
